import { OperatorTimelineParams } from '@clean-code/api/hooks/useOperatorTimeline';
import { PaginatedRequest } from '@clean-code/types/common';

export const SET_OPERATOR_FILTER = 'OPERATOR_TIMELINE/SET_FILTER';
export const RESET_OPERATOR_FILTERS = 'OPERATOR_TIMELINE/RESET_FILTERS';
export const SET_OPERATOR_SORTING = 'OPERATOR_TIMELINE/SET_SORTING';
export const SET_OPERATOR_PAGINATION = 'OPERATOR_TIMELINE/SET_PAGINATION';

//TODO: pending backend sorting
export type OperatorSorting = {
  column:
    | 'range_from'
    | 'operatorName'
    | 'shiftName'
    | 'machineName'
    | 'isAssigned';
  direction: 'asc' | 'desc';
};

export type OperatorTimelineState = {
  filter: OperatorTimelineParams;
  sorting?: OperatorSorting;
  pagination: PaginatedRequest;
};
